import * as React from "react";
import { translate } from "react-i18next";
import MembersOperationDialog from "./MembersOperationDialog";

export interface ChangeCommanderOperationDialogProps {
  newCommander: any,
  onChangeClick: () => void,
  onCloseClick: () => void,
  t: (str: string) => string
}

const ChangeCommanderOperationDialog = (props: ChangeCommanderOperationDialogProps) => {
  return (
    <MembersOperationDialog
      buttonActionTitle={props.t('Передать')}
      buttonCloseTitle={props.t('Закрыть')}
      controlElement={null}
      membersForOperate={[props.newCommander]}
      spinnerLabel={props.t('Передаем управление')}
      textBeforeMembers={props.t('Передать управление игроку')}
      title={props.t('Передача управления кланом')}
      onActionClick={props.onChangeClick}
      onCloseClick={props.onCloseClick}
    />
  )
}

export default translate()(ChangeCommanderOperationDialog);